/*
errorBody.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { TFunction } from 'i18next'
import { ErrorKey, ErrorType } from '../../modules/errors'

const ErrorBody = (
  error: ErrorType | undefined,
  t: TFunction<'translation', undefined>
) => {
  const isStringArray = (test: unknown[]): boolean => {
    return Array.isArray(test) && !test.some(value => typeof value !== 'string')
  }
  const renderTextKeys = (textKeys: (string | ErrorKey)[]) => {
    return (
      <>
      <div>
        {textKeys.map((item, index) => {
          const key = typeof item === 'string' ? item : item.key;
          const variables = typeof item === 'string' ? undefined : item.variables;
          return index == 0 ? (
            <div key={key}>
              <span>{t(key, variables)}</span> <br />
            </div>
          ) : (
            <div key={key}>
              <span className='pt-4' style={{ display: 'block' }}>
              {t(key, variables)}
              </span>
            </div>
          )
        })}
      </div>
      </>
    )
  }
  let renderItems
  if (error && error.keys) {
    if (isStringArray(error?.keys)) {
      const errorKeys = error.keys as string[]
      renderItems = renderTextKeys(errorKeys)
    } else {
      const errorKeys = error.keys as ErrorKey[]
      const keysWithListItems = errorKeys.filter(c => c.listItems)
      const keysWithoutListItems = errorKeys
        .filter(c => !c.listItems)
      renderItems = (
        <div>
          {renderTextKeys(keysWithoutListItems)}
          <ul className="pt-2">
            {keysWithListItems.map(c =>
              c.listItems?.map(l => (
                <li className="pt-1">
                  <span>{t(l)}</span>
                </li>
              ))
            )}
          </ul>
        </div>
      )
    }
  }
  return (
    <>
      {renderItems}
      {error?.bottomText && (
        <>
          <div>{t(error?.bottomText)}</div>
        </>
      )}
    </>
  )
}

export default ErrorBody